<template>
    <b-modal :id="$id('filterModal')" :visible="visible" centered no-close-on-backdrop no-close-on-esc size="lg">
        <template #modal-header="{ close }">
            <b-row class="w-100 p-0 m-0 h-100 " align-v="center">
                <b-col class="text-left">
                    <h6>{{$t('FiltersManagement')}}</h6>
                </b-col>
                <b-col class=" pr-0 p-1 pl-4 text-right">
                    <!-- Close : Fermer -->
                    <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close(); visible = false;" v-b-tooltip.hover :title="$t('Close')" />
                </b-col>
            </b-row>
        </template>

        <template #modal-footer="{ok,close}">
            <b-row>
                <!-- Cancel : Annuler -->
                <b-button @click="close(); visible = false; resetFilters()" pill :variant="'outline-' + Variant" class="mx-1">{{$t('Cancel')}}</b-button>
                <span id="disabledCheck" class="d-inline-block" tabindex="0">
                    <!-- Validate : Valider -->
                    <b-button @click="ok(); visible = false;" pill :variant="Variant" :disabled="checkFilters()">{{$t('Validate')}}</b-button>
                </span>
                <!-- ValidateTooltip : Chaque filtre doit avoir une valeur -->
                <b-tooltip v-if="checkFilters()" target="disabledCheck" triggers="hover">{{$t('ValidateTooltip')}}</b-tooltip>
            </b-row>
        </template>

        <!-- generateVariantStyle() permet de générer les variables Css dynamiques utilisables dans la section <style></style> -->
        <div :style="generateVariantStyle(Variant)">
            <!-- Bouton Ajout de filtre / Effacement sélection -->
            <b-row class="justify-content-between px-2">
                <hsc-menu-style-custom>
                    <hsc-menu-button-menu :menuZIndex="1000" class="w-100">
                        <!-- AddFilter : Filtre(s) -->
                        <b-button @click="getFilters" pill class="border border-gray text-black bg-gray-light" ><b-icon icon="plus" scale="1.5"/>{{$t('AddFilter')}}</b-button>
                        <template slot="contextmenu" v-for="filter in availablefilters">
                            <hsc-menu-item @click="addFilter(filter)" :disabled="lSelectedFilters.find(x => x.Name == filter.Name) != undefined" :label="filter.Label" />
                        </template>
                    </hsc-menu-button-menu>
                </hsc-menu-style-custom>
                <!-- ClearFilters : Effacer les filtres -->
                <b-link @click="resetFilters()" v-if="lSelectedFilters.length > 0" class="text-danger px-2"> {{$t('ClearFilters')}}</b-link>
                <!-- Indication aucun filtres sélectionnés -->
                <!-- NoFilterConfigured : Aucun filtre renseigné -->
                <label v-else class="px-2">{{$t('NoFilterConfigured')}}</label>
            </b-row>

            <!-- Affichage des selections des filtres -->
            <b-row v-if="lSelectedFilters.length > 0" cols="1">
                <b-row v-for="filter in lSelectedFilters" :key="filter.Name" align-v="center" class="pl-2 mb-2">
                    <!-- Affichage pour le filtre code budget -->
                    <template v-if="filter.Name == 'BudgetCode'">
                        <b-col cols="3">
                            <label class="mx-1">{{filter.Name}}</label>
                        </b-col>
                        <b-col cols="8">
                            <b-input-group :id="filter.Name" size="lg">
                                <b-form-input v-model="formula" readonly />
                                <template #append>
                                    <b-input-group-text class="bg-white" role="button" @click="budgetVisible = true;">
                                        <b-icon icon="search" />
                                    </b-input-group-text>
                                </template>
                            </b-input-group>
                        </b-col>
                        <b-col cols="1">
                            <b-icon @click="removeFilter('BudgetCode')" role="button" icon="x" scale="2" class="text-danger" />
                        </b-col>
                    </template>
                    <!-- Affichage pour tous les autres filtres -->
                    <template v-else>
                        <b-col cols="2" class="pr-0" align-self="center">
                            <label class="mx-1">{{ filter.Label }}</label>
                        </b-col>
                        <!-- Switch pour gestion inclus exclus sur un filtre -->
                        <b-col cols="1" class="px-0">
                            <!-- Included : Inclus || Excluded : Exclus -->
                            <b-form-checkbox switch v-model="filter.IsExcluded" :value="false" :unchecked-value="true" @change="createFilterString(filter.SelectedValues, filter.Name, filter.Options, filter.IsExcluded )" >{{ filter.IsExcluded ? $t('Excluded') : $t('Included') }}</b-form-checkbox>
                        </b-col>
                        <b-col cols="8" class="pr-0">
                            <!-- Select : Sélectionner -->
                              <!-- AndMore : et {count} de plus -->
                            <multiselect v-model="filter.SelectedValues"
                                        :id="filter.Name"
                                        :options="filter.Options"
                                        :multiple="true"
                                        label="Label"
                                        track-by="Id"
                                        :placeholder="$t('Select')"
                                        :searchable="false"
                                        :show-labels="false"
                                        :close-on-select="false"
                                        :max-height="200"
                                        open-direction="top"
                                        :limit="5"
                                        :limitText="count => $t('AndMore', {count})"
                                        @input="createFilterString($event, filter.Name, filter.Options, filter.IsExcluded)">

                                        <!-- Modification icone d'ouverture de la liste déroulante -->
                                <template #caret={toggle}>
                                    <span class="multiselect__select pr-0">
                                        <b-icon icon="chevron-down" font-scale="0.55" shift-h="7" style="stroke: black !important; stroke-width: 1.5px !important;"/>
                                    </span>
                                </template>
                            </multiselect>
                        </b-col>
                        <b-col cols="1">
                            <b-icon @click="removeFilter(filter.Name)" role="button" icon="x" scale="2" class="text-danger" />
                        </b-col>
                    </template>
                    
                </b-row>

            </b-row>

            <!-- Modal permettant la configuration du code budget -->
            <CodesBudget :Visible.sync="budgetVisible" :SModel.sync="sModel" :SFormulaCode.sync="formulaCode" :SFormula.sync="formula" :Variant="Variant" />
        </div>
    </b-modal>
</template>

<script lang="ts">
    import { PropSync, Watch, Prop } from 'vue-property-decorator';
    import { Getter } from 'vuex-class';
    import Component, { mixins } from 'vue-class-component';
    import { ThemeUtils } from "@/components/commons/Utils";
    import ListItem from "@/types/fields/ListItem";
    import Multiselect from 'vue-multiselect';
    import CodesBudget from './CodesBudget.vue';
    import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
    import Filter from '@/types/Config/Filter';
    /** Traductions */
    import locales from "./locales/Filters.json";

    /** Permet d'afficher une modale pour la sélection de filtres */
    @Component({
        components: {
            'hsc-menu-style-custom': HscMenuStyleCustom("secondary"),
            Multiselect,
            CodesBudget
        },
        i18n: { messages: locales }
    })
    export default class Filters extends mixins(ThemeUtils) {
        //#region Props

        /** Variant de couleur à appliquer sur le composant */
		@Prop({ default: () => "secondary"})
		public Variant!: string;

        /** Permet d'afficher ou non la modale */
        @PropSync('Visible', { default: () => false }) /** type: boolean, */
        public visible!: boolean;

        /** Permet de récupérer les liste chargées*/
        @PropSync('PerimeterList', { default: () => "" })
        public perimeterList!: string;

        /** Permet de récupérer le type de données sélectionnée */
        @PropSync('DataType', { default: () => "" })
        public dataType!: string;

        /** Permet de récupérer la répartition sélectionnée */
        @PropSync('Distribution', { default: () => "" })
        public distribution!: string;

        /** Permet de transmettre ou recupérer les vocations sélectionnées*/
        @PropSync('Purposes', { default: () => "" })
        public sPurpose!: string;

        /** Permet de transmettre ou récupérer les usages sélectionnés*/
        @PropSync('Uses', { default: () => "" })
        public sUse!: string;

        /** Permet de transmettre ou récupérer les energies sélectionnées*/
        @PropSync('Expendable', { default: () => "" })
        public sFilterExpendables!: string;

        /** Permet de transmettre ou récupérer les couts sélectionnées*/
        @PropSync('Costs', { default: () => "" })
        public sCost!: string;

        /** Permet de transmettre ou récupérer les fournisseur sélectionnés*/
        @PropSync('Providers', { default: () => "" })
        public sProvider!: string;

        /** Permet de transmettre ou récupérer les contrats sélectionnés*/
        @PropSync('Contracts', { default: () => "" })
        public sContract!: string;

        /** Permet de transmettre ou récupérer les tarifs sélectionnés*/
        @PropSync('Tariffs', { default: () => "" })
        public sTariff!: string;

        /** Permet de transmettre ou récupérer les propriétaires sélectionnés*/
        @PropSync('Owner', { default: () => "" })
        public sOwner!: string;

        /** Permet de transmettre ou récupérer les types d'objet sélectionnés*/
        @PropSync('ObjectType', { default: () => "" })
        public sObjectType!: string;

        /** Permet de transmettre ou récupérer les titulaires d'abonnement sélectionnés*/
        @PropSync('SubscriptionHolder', { default: () => "" })
        public sSubscriptionHolder!: string;

        /** Permet de transmettre ou récupérer les payeur facture sélectionnés*/
        @PropSync('PayingInvoice', { default: () => "" })
        public sPayingInvoice!: string;

        /** Propriété correspondant à la nomenclature selectionnée */
        @PropSync("SModel", { default: () => 0 })
        public sModel!: number;

        /** Chaine correspondant à la formule du code budget */
        @PropSync("SFormulaCode", { default: () => "" })
        public formulaCode!: string;

        /** Liste des filtres sélectionnés */
        @PropSync("SelectedFilters", { default: () => [] })
        public selectedFilters!: Filter[];
        //#endregion Props

        /** Liste local des filtres sélectionnés */
        private lSelectedFilters: { Name: string, Label: string, Options: {Id: number, Label: string}[], SelectedValues: {Id: number, Label: string}[], IsExcluded : boolean, Values: string }[] = [];

        //#region Getters

        /** Getter pour obtenir une liste filtrée selon le périmètre de l'utilisateur */
        @Getter('GetPerimeterItems')
        private perimeterItems!: (listName: string) => any[];

        /** Getter pour obtenir une liste */
        @Getter('GetListItems')
        private listItems!: (listName: string) => ListItem[];

        //#endregion Getters

        //#region Filtres

        /** Liste des tous les filtres possibles - les éléments commentés ne sont pas encore gérés par la procédure **/
        private filterList: { Name: string, Label: string }[] = [
            { Name: "Expendable", Label: this.$t('FilterLabels.Expendable').toString() }, // Énergie et fluide
            { Name: "Purpose", Label: this.$t('FilterLabels.Purpose').toString() }, // Vocation
            { Name: "UsageType", Label: this.$t('FilterLabels.UsageType').toString() }, // Usage
            { Name: "BudgetCode", Label: this.$t('FilterLabels.BudgetCode').toString() }, // Code Budget
            { Name: "CostType", Label: this.$t('FilterLabels.CostType').toString() }, // Details Coût
            { Name: "Contract", Label: this.$t('FilterLabels.Contract').toString() }, // Contrats
            { Name: "Provider", Label: this.$t('FilterLabels.Provider').toString() }, // Fournisseur
            { Name: "Tariff", Label: this.$t('FilterLabels.Tariff').toString() } // Tarif
            // { Name: "Owner", Label: "Propriétaire" },
            // { Name: "ObjectType", Label: "Type Objet" },
            // { Name: "PayingInvoice", Label: "Payeur Facture" },
            // { Name: "SubscriptionHolder", Label: "Tutulaire Abonnement" },
        ]

        /** Liste des filtres selectionables (Values dépend du périmètre de l'utilisateur) 
        ** Ex: Name => Purpose | Label => Vocation | Selected => 1,2,8,15,21,25,29,37,50*/
        private availablefilters: Filter[] = [];

        /** Permet de récupérer la liste des filtres affichables selon le périmètre utilisateur */
        private getFilters() {
            // On réinitialise la liste des filtres sélectionnables
            this.availablefilters = [];

            // Liste des valeurs utilisables par l'utilisateur(Expendable, Purpose, Provider, ... ) sous forme de tableau 
            let lists: string[] = this.perimeterList.split(',');

            // Copie de la liste des filtres
            let tmpFilterList: { Name: string, Label: string }[] = [...this.filterList];

            // Si le type de données est Conso / Livraison, on enlève le filtre des énergies
            if (this.dataType == 'Consumption') {
                let index = tmpFilterList.findIndex(x => x.Name == 'Expendable');
                tmpFilterList.splice(index, 1);
            }

            // Boucle et insertion dans la liste des filtres disponibles
            for (var i = 0; i < tmpFilterList.length; i++) {

                if (this.perimeterItems(lists[i]).length != 0) {
                    let filter = tmpFilterList.find(s => s.Name == lists[i]);
                    if (filter)
                        this.availablefilters.push({ Name: filter.Name, Label: filter.Label, Values: "", IsExcluded: false });
                }

                // Insertion pour le code budget
                if (tmpFilterList[i].Name == "BudgetCode" && tmpFilterList.find(s => s.Name == lists[i]))
                    this.availablefilters.push({ Name: tmpFilterList[i].Name, Label: tmpFilterList[i].Label, Values: "", IsExcluded : false });
            }
            console.debug("Filters - getFilters - availableFilters :", this.availablefilters)
        }

        /**
         * Permet d'ajouter un des filtres disponibles
         * @param filter 
         */
        private addFilter(filter: Filter) {
            // Si le filtre n'existe pas on l'ajoute
            if (this.lSelectedFilters.find(x => x.Name == filter.Name ) == undefined){
                let name = filter.Name;
                let label = filter.Label;
                let options : {Id: number, Label: string}[];
                let selectedValues : {Id: number, Label: string}[];
                
                // switch pour instantiation spécifique pour chaque type de filtre
                switch(filter.Name){
                    case "Expendable":
                        options = this.filteredExpendable();

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedExpendables = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString())); 
                            else
                                this.selectedExpendables = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }
                        
                        selectedValues = this.selectedExpendables;
                        break;
                    case "UsageType":
                        options = this.filteredUses();

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedUses = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString()));
                            else
                                this.selectedUses = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }

                        selectedValues = this.selectedUses;
                        break;
                    case "Purpose":
                        options = this.filteredPurpose();

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedPurposes = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString()));
                            else
                                this.selectedPurposes = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }

                        selectedValues = this.selectedPurposes;
                        break;
                    
                    case "Provider":
                        options = this.filteredProviders();

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedProviders = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString()));
                            else
                                this.selectedProviders = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }
                            selectedValues = this.selectedProviders;
                        break;
                    case "Tariff":
                        options = this.filteredTariffs();

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedTariffs = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString()));
                            else
                                this.selectedTariffs = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }

                        selectedValues = this.selectedTariffs;
                        break;
                    case "Contract":
                        options = this.filteredContracts();

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedContracts = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString()));
                            else
                                this.selectedContracts = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }
                                           
                        selectedValues = this.selectedContracts;
                        break;
                    case "Owner":
                        options = this.filteredOwners();

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedOwners = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString()));
                            else
                                this.selectedOwners = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }

                        selectedValues = this.selectedOwners;
                        break;
                    case "SubscriptionHolder":
                        options = this.filteredSubscriptions();

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedSubscriptions = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString()));
                            else
                                this.selectedSubscriptions = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }

                        selectedValues = this.selectedSubscriptions;
                        break;
                    case "ObjectType":
                        options = this.filteredObjectTypes();

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedObjectTypes = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString()));
                            else
                                this.selectedObjectTypes = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }

                        selectedValues = this.selectedObjectTypes;
                        break;
                    case "PayingInvoice":
                        options = this.filteredPaying();

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedPaying = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString()));
                            else
                                this.selectedPaying = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }

                        selectedValues = this.selectedPaying;
                        break;
                    case "CostType":
                        options = this.listItems('CostType');

                        if(filter.Values.length > 0){
                            if(filter.IsExcluded)
                                this.selectedCosts = options.filter(x => !filter.Values.split(',').some(v => v === x.Id.toString()));
                            else
                                this.selectedCosts = options.filter(x => filter.Values.split(',').some(v => v === x.Id.toString()));
                        }

                        selectedValues = this.selectedCosts;
                        break;
                }

                // Ajoute sur la liste local
                this.lSelectedFilters.push({ Name: name, Label: label, Options: options, IsExcluded: filter.IsExcluded, SelectedValues: selectedValues, Values: "" });
                
                // Ajoute sur la liste à transmettre
                if(this.selectedFilters.find(x => x.Name == filter.Name ) == undefined)
                    this.selectedFilters.push({Name: name, Label: label, Values: "", IsExcluded : false});
                else
                    this.createFilterString(selectedValues, filter.Name, options, filter.IsExcluded);
            }
            console.debug("Filters - addFilter - selectedFilters :", this.lSelectedFilters);
        }

        /**
         * Permet de supprimer le filtre
         * @param filterName Nom du filtre
         */
        private removeFilter(filterName){
            console.debug("Filters - removeFilter - filterName : ", filterName);

            // Suppression du filtre local
            this.lSelectedFilters.splice(this.lSelectedFilters.findIndex(s => s.Name == filterName), 1);

            // Suppression du filtre à transmettre
            this.selectedFilters.splice(this.selectedFilters.findIndex(s => s.Name == filterName), 1);

            // Mise à jour des prop
            this.updateProp(filterName, null);
        }

        /** Remet à zéro les filtres */
        private resetFilters() {
            //vide la selection de filtres
            this.lSelectedFilters = [];
            this.selectedFilters = [];

            //vide la sélection de chaque filtre
            this.selectedContracts = [];
            this.sContract = null;
            this.selectedCosts = [];
            this.sCost = null;
            this.selectedProviders = [];
            this.sProvider = null;
            this.selectedPurposes = [];
            this.sPurpose = null;
            this.selectedTariffs = [];
            this.sTariff = null;
            this.selectedUses = [];
            this.sUse = null;
            this.selectedExpendables = [];
            this.sFilterExpendables = null;
            this.selectedOwners = [];
            this.sOwner = null;
            this.selectedSubscriptions = [];
            this.sSubscriptionHolder = null;
            this.selectedPaying = [];
            this.sPayingInvoice = null;
            this.selectedObjectTypes = [];
            this.sObjectType = null;

            // resetBudget
            this.sModel = null;
            this.formula = '';
            this.formulaCode = null;
        }

        /**
         * Permet de créer la chaîne de caractères des identifiants des valeurs du filtre sélectionné
         * @param values Liste des valeurs sélectionnées
         * @param filterName Nom du filtre
         * @param options Liste des valeurs disponibles
         * @param isExcluded Passage en exclusion ou non sur le filtre 
         */
        private createFilterString(values: any[], filterName: string, options: any[], isExcluded: boolean ){
            console.debug("Filters - createFilterString() : %O - filterName : %s - options : %O - isExcluded : %O", values, filterName, options, isExcluded);

            let filter : Filter = this.selectedFilters.find(x => x.Name == filterName);
            let idsString: string = "";

            if(isExcluded && values.length > 0){
                // filtre la liste contenant toutes les options en y enlevant les lignes présentes dans la liste des élements sélectionnés et on crée une chaine avec les identifiants retournés séparé par une virgule
                idsString = options.filter(o => !values.some(v => v.Id === o.Id)).map(x => x.Id).join(",");
                console.debug("Filters - createFilterString() - idsString Excluded : %s", idsString);
            }
            else{
                idsString = values.map((x) => x.Id).join(",");
                console.debug("Filters - createFilterString() - idsString Included : %s", idsString);
            }

            filter.IsExcluded = isExcluded;
            filter.Values = idsString;

            this.updateProp(filterName, idsString);
        }

        /**
         * Met à jour la prop selon le nom du filtre
         * @param filterName Nom du filtre
         * @param values Nouvelle Valeur 
         */
        private updateProp(filterName : string, values: string){
            console.debug("Filters - updateProp() - filterName : %s - values : %s", filterName, values);

            switch(filterName){
                case "Expendable":
                    this.sFilterExpendables = values;
                    break;
                case "UsageType":
                    this.sUse = values;
                    break;
                case "Purpose":
                    this.sPurpose = values;
                    break;
                case "Provider":
                    this.sProvider = values;   
                    break;
                case "Tariff":
                    this.sTariff = values;
                    break;
                case "Contract":
                    this.sContract = values;
                    break;
                case "Owner":
                    this.sOwner = values;
                    break;
                case "SubscriptionHolder":
                    this.sSubscriptionHolder = values;
                    break;
                case "ObjectType":
                    this.sObjectType = values;
                    break;
                case "PayingInvoice":
                    this.sPayingInvoice = values;
                    break;
                case "CostType":
                    this.sCost = values;
            }
        }

        /** Liste des vocations sélectionnées */
        private selectedPurposes: { Id: number, Label: string }[] = [];

        /** Filtre la liste des vocations disponibles selon le périmètre de l'utilisateur */
        private filteredPurpose() {
            let filterPurposes: { Id: number, Label: string }[] = [];
            filterPurposes = this.listItems('Purpose').filter(x => (this.perimeterItems('Purpose').includes(x.Id)));
            return filterPurposes;
        }

        /** Met à jour la liste des vocations selectionnées par rapport aux vocations enregistrées dans le widget */
        @Watch('sPurpose', { immediate: true })
        private updatePurposes() {
            if (this.sPurpose)
                this.selectedPurposes = this.listItems("Purpose").filter(x => (this.sPurpose.split(",")).includes(x.Id.toString()));
        }

        /** Liste des usages sélectionnées */
        private selectedUses: { Id: number, Label: string }[] = [];
        
        /** Filtre la liste des usages disponibles selon le périmètre de l'utilisateur */
        private filteredUses() {
            let filterUses: { Id: number, Label: string }[] = [];

            if (this.perimeterItems && this.perimeterItems('UsageType')) {
                let items: number[] = this.perimeterItems('UsageType');
                filterUses = this.listItems('UsageType').filter(x => (items.includes(x.Id)));

                // Vu que la valeur 0 n'existe pas dans le listItems car provient du serveur, on l'a rajoute
                if (items && items.includes(0))
                    filterUses.push({ Id: 0, Label: this.$t('Undetermined').toString() });

            }
            return filterUses;
        }

        /** Met à jour la liste des usages selectionnés par rapport aux usages enregistrés dans le widget */
        @Watch('sUse', { immediate: true })
        private updateUses() {
            if (this.sUse){
                this.selectedUses = this.listItems("UsageType").filter(x => (this.sUse.split(",")).includes(x.Id.toString()));

                // Vu que la valeur 0 n'existe pas dans le listItems car provient du serveur, on l'a rajoute
                if(this.sUse.split(",").includes("0"))
                    this.selectedUses.push({ Id: 0, Label: this.$t('Undetermined').toString() });
            }
        }

        /** Liste des energies sélectionnées pour le filtre */
        private selectedExpendables: { Id: number, Label: string }[] = [];

        /** Filtre la liste des énergies & fluides disponibles selon le périmètre de l'utilisateur */
        private filteredExpendable() {
            let filterExpendable: { Id: number, Label: string }[] = [];
            filterExpendable = this.listItems('Expendable').filter(x => (this.perimeterItems('Expendable').includes(x.Id)));

            return filterExpendable;
        }

        /** Met à jour la liste des energies selectionnées par rapport aux énergies enregistrées dans le widget */
        @Watch('sFilterExpendables', { immediate: true })
        private updateFilterExpendable() {
            console.debug("Filters - updateFilterExpendable() - selectedFilters", this.lSelectedFilters);

            if (this.sFilterExpendables)
                this.selectedExpendables = this.listItems("Expendable").filter(x => (this.sFilterExpendables.split(",")).includes(x.Id.toString()));
        }

        /** Liste des couts sélectionnées */
        private selectedCosts: { Id: number, Label: string }[] = [];

        /** Met à jour la liste des couts selectionnées par rapport aux vocations enregistrées dans le widget */
        @Watch('sCost', { immediate: true })
        private updateCosts() {
            if (this.sCost)
                this.selectedCosts = this.listItems("CostType").filter(x => (this.sCost.split(",")).includes(x.Id.toString()));
        }
        
        /** Liste des fournisseurs sélectionnés */
        private selectedProviders: { Id: number, Label: string }[] = [];

        /** Filtre la liste des fournisseurs disponibles selon le périmètre de l'utilisateur */
        private filteredProviders() {
            let filteredProviders: { Id: number, Label: string }[] = [];
            filteredProviders = this.listItems('Provider').filter(x => (this.perimeterItems('Provider').includes(x.Id)));
            return filteredProviders;
        }

        /** Met à jour la liste des fournisseurs selectionnés par rapport aux fournisseurs enregistrés dans le widget */
        @Watch('sProvider', { immediate: true })
        private updateProviders() {
            if (this.sProvider)
                this.selectedProviders = this.listItems("Provider").filter(x => (this.sProvider.split(",")).includes(x.Id.toString()));
        }

        /** Liste des contrats sélectionnés */
        private selectedContracts: { Id: number, Label: string }[] = [];

        /** Filtre la liste des contrats disponibles selon le périmètre de l'utilisateur */
        private filteredContracts() {
            let filteredContracts: { Id: number, Label: string }[] = [];
            filteredContracts = this.listItems('Contract').filter(x => (this.perimeterItems('Contract').includes(x.Id)));

            return filteredContracts;
        }

        /** Met à jour la liste des couts selectionnées par rapport aux vocations enregistrées dans le widget */
        @Watch('sContract', { immediate: true })
        private updateContracts() {
            if (this.sContract)
                this.selectedContracts = this.listItems("Contract").filter(x => (this.sContract.split(",")).includes(x.Id.toString()));
        }

        /** Liste des tarifs sélectionnés */
        private selectedTariffs: { Id: number, Label: string }[] = [];

        private filteredTariffs() {
            let filteredTariffs: { Id: number, Label: string }[] = [];

            filteredTariffs = this.listItems('Tariff').filter(x => (this.perimeterItems('Tariff').includes(x.Id)));

            return filteredTariffs;
        }

        /** Met à jour la liste des tarifs selectionnés par rapport aux tarifs enregistrés dans le widget */
        @Watch('sTariff', { immediate: true })
        private updateTariffs() {
            if (this.sTariff)
                this.selectedTariffs = this.listItems("Tariff").filter(x => (this.sTariff.split(",")).includes(x.Id.toString()));
        }

        /** Indique si on affiche la modale des budgets */
        private budgetVisible: boolean = false;

        /** 
         *  correspond à la formule affiché
         * Ex: ( 1 OU 8) ET 58 
         */
        private formula: string = "";

        /** Liste des propriétaires sélectionnés */
        private selectedOwners: { Id: number, Label: string }[] = [];

        private filteredOwners() {
            let filteredOwners: { Id: number, Label: string }[] = [];
            let owners = this.perimeterItems('Owner');

            for (var i = 0; i < owners.length; i++) {
                filteredOwners.push({ Id: i, Label: owners[i] });
            }

            return filteredOwners;
        }

        /** Met à jour la liste des propriétaires selectionnés par rapport aux vocations enregistrées dans le widget */
        @Watch('sOwner', { immediate: true })
        private updateOwners() {
            if (this.sOwner)
                this.selectedOwners = this.filteredOwners().filter(x => (this.sOwner.split(",")).includes(x.Id.toString()));
        }

        /** Liste des type d'objets sélectionnés */
        private selectedObjectTypes: { Id: number, Label: string }[] = [];

        private filteredObjectTypes() {
            let filteredObjectTypes: { Id: number, Label: string }[] = [];
            filteredObjectTypes = this.listItems('ObjectType').filter(x => (this.perimeterItems('ObjectType').includes(x.Id)));
            return filteredObjectTypes;
        }

        /** Met à jour la liste des propriétaires selectionnés par rapport aux vocations enregistrées dans le widget */
        @Watch('sObjectType', { immediate: true })
        private updateObjectTypes() {
            if (this.sObjectType)
                this.selectedObjectTypes = this.listItems("ObjectType").filter(x => (this.sObjectType.split(",")).includes(x.Id.toString()));
        }

        private selectedSubscriptions: { Id: number, Label: string }[] = [];

        private filteredSubscriptions() {
            let filteredSubscriptions: { Id: number, Label: string }[] = [];
            let subscriptions = this.perimeterItems('SubscriptionHolder');

            for (var i = 0; i < subscriptions.length; i++) {
                filteredSubscriptions.push({ Id: i, Label: subscriptions[i] });
            }

            return filteredSubscriptions;
        }

        /** Met à jour la liste des titulaires d'abonnement selectionnés par rapport aux titulaires d'abonement enregistrées dans le widget */
        @Watch('sSubscriptionHolder', { immediate: true })
        private updateSubscriptions() {
            if (this.sSubscriptionHolder)
                this.selectedSubscriptions = this.filteredSubscriptions().filter(x => (this.sSubscriptionHolder.split(",")).includes(x.Id.toString()));
        }

        private selectedPaying: { Id: number, Label: string }[] = [];

        private filteredPaying() {
            let filteredPaying: { Id: number, Label: string }[] = [];
            let paying = this.perimeterItems('PayingInvoice');

            for (var i = 0; i < paying.length; i++) {
                filteredPaying.push({ Id: i, Label: paying[i] });
            }

            return filteredPaying;
        }

        /** Retourne un booléen indiquant si tous les filtres sélectionnés ont une valeur */
        private checkFilters(){
            console.debug("Filters - checkFilters - selectedFilters : %O | lSelectedFilters : %O ", this.selectedFilters, this.lSelectedFilters);

            return this.selectedFilters.length > 0 && !(this.selectedFilters.every((x) => x.Values && x.Values.length > 0));
        }

        //#endregion Filtres
        
        mounted(){
            // Si des filtres sont déjà présents
            for(let filter of this.selectedFilters)
            {
                console.debug("Filters - mounted - filter - IsExcluded", filter.IsExcluded);

                this.addFilter(filter);
            }
        }
    }
</script>

<style scoped>
    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
    :deep(.custom-control-input:checked ~ .custom-control-label::before) {
        border-color: var(--Variant) !important;
        background-color: var(--Variant) !important;
    }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
    :deep(.custom-control-input:active ~ .custom-control-label::before) {
        background-color: var(--Variant) !important;
        border-color: var(--Variant) !important;
    }
</style>